import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 45%;
  color: #fff;
  margin: 15px;
  font-size: 4em;
  padding: 0 4rem;
  font-weight: 700;
`;
